import { useTFF } from "@hooks/useTFF"
import { safeStorage } from "@utils/safeStorage"
import { useHydrating } from "eddev/routing"

type BackButton = {
  url: string
  label: string
  date?: number
}

export function useProgramBackButton() {
  const hydrating = useHydrating()

  const tff = useTFF()

  return {
    remember(url: string, label: string) {
      if (!env.client) return
      safeStorage.setData<BackButton>("program-back-button", { url, label, date: Date.now() })
    },
    getBackButton(): BackButton {
      if (tff.isTFF) {
        if (tff.routeCenter) {
          return {
            label: `${tff.routeCenter.title} Program`,
            url: tff.routeCenter.uri!,
          }
        } else {
          return {
            label: "Travelling Film Festival",
            url: "/tff/",
          }
        }
      }

      if (env.client && !hydrating) {
        const backButton = safeStorage.getData<BackButton>("program-back-button")
        if (backButton && backButton.date && backButton.date > Date.now() - 1000 * 60 * 60 * 1) {
          return backButton
        }
      }
      return {
        url: "/program/",
        label: "View full program",
      }
    },
  }
}
